module.exports = __webpack_public_path__ + "img/receipt.3314bd92.svg";